exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.background-darken[data-v-220d4c12] {\n  background: rgba(0, 0, 0, 0.3);\n}\n.modal[data-v-220d4c12] {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-full[data-v-220d4c12] {\n  margin-left: 16px;\n  margin-right: 16px;\n  width: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-220d4c12&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Vue2BootstrapModal.vue
// module id = 7
// module chunks = 0